import { uuidv4 } from '@/util'

export default {
  data () {
    return {
      elementId: `map-${uuidv4()}`,
      map: undefined,
      mapBox: undefined,
      style: undefined
    }
  },
  mounted () {
    import(/* webpackChunkName: "mapbox" */'mapbox-gl/dist/mapbox-gl.js')
      .then(this.initialize)
  },
  destroyed () {
    this.map && this.map.remove()
  },
  methods: {
    initialize (mapBox) {
      const capabilities = this.$store.state.identity.capabilities
      if (capabilities && capabilities.map_box) {
        this.mapBox = mapBox.default
        this.mapBox.accessToken = capabilities.map_box.access_token
        this.mapBox.style = capabilities.map_box.style
        this.onReady && this.onReady(this.mapBox)
      } else {
        this.onError && this.onError()
      }
    },
    createMap (options) {
      const finalOptions = Object.assign({
        container: this.elementId,
        style: this.mapBox.style
      }, options)
      this.map = new this.mapBox.Map(finalOptions)
      return this.map
    }
  }
}
